import axios from '../axios/axios-auth'

export default class MachineReportService {
    createMachineReport(organization_id, payload) {
        return axios.post(`/parametric-failures-service/v1/machine-report/organization/${organization_id}`, payload).then(response => response.data)
    }

    getMachineReport(organization_id) {
        return axios.get(`/parametric-failures-service/v1/machine-report/organization/${organization_id}`).then(response => response.data)
    }

    downloadCsv(report_id, organization_id) {
        return axios.get(`/parametric-failures-service/v1/machine-report/${report_id}/download/organization/${organization_id}`).then(response => response.data)
    }

    deleteMachineReport(report_id, organization_id) {
        return axios.delete(`/parametric-failures-service/v1/machine-report/${report_id}/organization/${organization_id}`).then(response => response.data)
    }
}
